import './App.css';
import { HashScrollManager } from './components/HashScrollManager';
import { PortfolioPreviews } from './previews/PortfolioPreviews';

function App() {
  return <>
    <HashScrollManager />
    <PortfolioPreviews />
  </>;
}

export default App;
